import { IndexableObject } from '../IndexableObject';
import { useFocused, SharedFocusedProps } from '../useFocused';
import type { JSX } from 'react';

export interface FocusProviderProps
  extends SharedFocusedProps,
    IndexableObject {
  children: ({ focused, onFocus, onBlur }: SharedFocusedProps) => JSX.Element;
}

const FocusProvider = (props: FocusProviderProps) => {
  return props.children(useFocused(props));
};

FocusProvider.displayName = 'FocusProvider';

export default FocusProvider;
